import {Cureus} from '../Cureus';

Cureus.EmailListIndex = {};
//= require_tree ./EmailListIndex
